import * as validate from "validate.js";
import core_rule from 'Core/config/validate_rule';

let rule = {
    phone: {
        format: {
            pattern: /^[0][1-9]\d{6,9}$|^[1-9]\d{6,9}$/,
            message(value) {
                return validate.format("Invalid!", {
                    num: value
                });
            }
        }
    },
    required: {
        presence: {
            allowEmpty: false,
            message: "^emptyErrorMessage"
        }
    },
    name: {
        presence: { allowEmpty: false }
    },
    number: {
        presence: {
            allowEmpty: false,
            message: "^emptyErrorMessage"
        },
        numericality: { message: "^numberErrorMessage " }
    },
    file: {
        presence: {
            allowEmpty: false,
            message: "^emptyFileErrorMessage"
        }
    },
    email: {
        presence: {
            allowEmpty: false,
            message: "^emptyErrorMessage"
        },
        email: {
            message: "^invalidErrorMessage"
        }
    },
    role: {
        presence: {
            message: "^noselectErrorMessage"
        }
    },
    select: {
        presence: {
            allowEmpty: false,
            message: "^noselectErrorMessage"
        }
    },
    datepicker: {
        presence: {
            allowEmpty: false,
            message: "^noselectErrorMessage"
        }
    },
    password: {
        presence: {
            allowEmpty: false,
            message: "^emptyErrorMessage"
        },
        length: {
            minimum: 6,
            message: "^lengthInsufficentErrorMessage6"
        }
    },
    confirmPassword: (attribute = "password") => {
        return {
            presence: {
                allowEmpty: false,
                message: "^emptyErrorMessage"
            },
            equality: {
                attribute: attribute,
                message: "^passwordconfirmInvalidErrorMessage",
                comparator: function(v1, v2) {
                    return JSON.stringify(v1) === JSON.stringify(v2);
                }
            }
        };
    },
    gender: {
        presence: {
            message: "must be selected!"
        }
    },
    homeno: {
        presence: { allowEmpty: false }
    },
    postalcode: {
        presence: { allowEmpty: false }
    },
    hiredDate: {
        presence: true
    },
    slug: {
        presence: { allowEmpty: false, message: "^emptyErrorMessage" },
        length: {
            is: 3,
            message: "^lengthMustBeExactErrorMessage3"
        }
    }
};

Object.assign(rule, core_rule.rule);

export default { rule };
